import styled from "styled-components";
import { Input as InputAntd } from "antd";
const { Search } = InputAntd;

export const ContainerNoText = styled.div`
  margin-top: 19px;
`;

export const ComponentInputSearch = styled(Search)`
.ant-btn-loading  svg {
  color: green
  font-size: 18px
  font-weight: bold
}
`
